"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extract = void 0;

const extract = (className, cssInJs, defaultProps = {}) => {
  return {
    className,
    cssInJs,
    defaultProps
  };
};

exports.extract = extract;